module.exports = __webpack_public_path__ + "img/graph-svgrepo-com.5e658b19.svg";